module.exports = __webpack_public_path__ + "img/science.210f83ea.png";